import { useQuery } from '@tanstack/react-query';
import { getForecast } from '../api/services/forecastService';
import type { ForecastResponseApi } from '../api/models/forecast';
import { useApp } from '../contexts/AppContext';

export function useForecast(period: string) {
  const { mode } = useApp();
  const isLive = mode === 'live';

  return useQuery<ForecastResponseApi>({
    queryKey: ['forecast', period],
    queryFn: () => getForecast(period),
    enabled: isLive,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
